import "./newsletter.css";

type NewsletterProps = {
  heading: string;
  paragraph: string;
  cta: string;
};

const Newsletter = (props: NewsletterProps) => {
  return (
    <div
      className="newsletter"
      role="region"
      aria-labelledby="newsletter-heading"
    >
      <div className="newsletter__container">
        <div className="newsletter__container__details">
          <h2 id="newsletter-heading">{props.heading}</h2>
          <p>{props.paragraph}</p>
        </div>

        <div className="newsletter__container__join">
          <p>{props.cta}</p>
          <div className="newsletter__container__join__input">
            <input
              type="email"
              placeholder="Email Address"
              aria-label="Email address for newsletter subscription"
            />
            <button aria-label="Subscribe to newsletter" tabIndex={0}>
              Subscribe
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Newsletter;
